import React, { useState, useEffect } from "react";
import "./SubStyle.css";
import Dashboard from "../images/CQC-Dashboard.9388082255a68f2f01b5.png"
import Dashboard_1 from "../images/CQC-Dashboard.9388082255a68f2f01b5.png"

const services = [
  {
    number: "01",
    title: "CQC registration",
    description:
      "End-to-end support for new provider, registered manager and location applications, including your Statement of Purpose.",
  },
  {
    number: "02",
    title: "Mock inspections",
    description:
      "A robust review against the CQC quality statements, with evidence-based findings and a practical improvement plan.",
  },
  {
    number: "03",
    title: "Compliance audits",
    description:
      "Focused audits of governance, care records, medicines, safeguarding, recruitment and other key regulatory areas.",
  },
  {
    number: "04",
    title: "Inspection readiness",
    description:
      "Evidence reviews, staff preparation and leadership support so your service can approach inspection with confidence.",
  },
  {
    number: "05",
    title: "Action plans & recovery",
    description:
      "Structured support following inspection, concerns or enforcement action, with clear priorities, owners and evidence.",
  },
  {
    number: "06",
    title: "Ongoing CQC assurance",
    description:
      "Regular compliance reviews, regulatory updates and independent oversight to help you remain inspection-ready.",
  },
];

const helpItems = [
  "Residential care homes",
  "Nursing homes",
  "Domiciliary care",
  "Supported living",
  "Care home groups",
  "New care providers",
];

const faqs = [
  {
    question: "What does CQC registration support include?",
    answer:
      "We support providers through the registration process, including application preparation, Statement of Purpose, evidence requirements, registered manager preparation and submission support.",
  },
  {
    question: "Can you help us prepare for a CQC inspection?",
    answer:
      "Yes. We can carry out a mock inspection, review your evidence, identify gaps and help your team prepare for the inspection process.",
  },
  {
    question: "Do you support existing care providers?",
    answer:
      "Yes. Our support can be tailored to existing providers who need ongoing CQC assurance, compliance audits, action plans or support with registration changes.",
  },
  {
    question: "How quickly can we start?",
    answer:
      "We can normally arrange an initial consultation to understand your current position and agree the most appropriate support.",
  },
];

function CQC_Services() {

 const [formData, setFormData] = useState({
   name: "",
   email: "",
   organisation: "",
 });

 const handleChange = (e) => {
   setFormData({
     ...formData,
     [e.target.name]: e.target.value,
   });
 };

 const handleSubmit = (e) => {
   e.preventDefault();

   const subject = encodeURIComponent(
     "Consultation Request - Total Care Advisory",
   );

   const body = encodeURIComponent(
     `Hello Total Care Advisory,

      I would like to request a consultation.

      Name: ${formData.name}
      Work Email: ${formData.email}
      Organisation: ${formData.organisation}

      Regards,
      ${formData.name}`,
        );

        window.location.href = `mailto:info@totalcareadvisory.com?subject=${subject}&body=${body}`;
      };


  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const scrollTo = (id) => {
    setMenuOpen(false);
    setServicesOpen(false);

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

   // open page on top //
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    // open page on top // 

  return (
    <div className="cqc-page">
      {/* ================= HERO ================= */}
      <section id="top" className="cqc-hero">
        <div className="cqc-container cqc-hero-grid">
          <div className="cqc-hero-content">
            <div className="cqc-eyebrow">CQC EXPERTISE FOR CARE PROVIDERS</div>

            <h1>
              CQC compliance,
              <br />
              approached with
              <br />
              confidence.
            </h1>

            <p>
              Specialist registration, mock inspection, compliance and
              improvement support for care providers. Know where you stand, what
              to strengthen and how to evidence good care.
            </p>
            <div className="cqc-hero-buttons">
              <a
                href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
                className="btn btn-primary"
              >
                Book a free consultation
              </a>
              <a href="#Intro" className="btn btn-secondary">
                Explore our services
              </a>
            </div>

            <div className="cqc-hero-note">
              ✓ Built around the CQC framework. Practical guidance aligned to
              quality statements and regulatory requirements.
            </div>
          </div>
          <div className="cqc-dashboard">
            <img src={Dashboard_1} alt="" />
          </div>
        </div>
    
      {/* Scroll Down */}
      <div className="scroll-down">
        <div className="mouse">
          <span></span>
        </div>
        <small>SCROLL DOWN</small>
      </div>
      </section>

      {/* ================= FEATURES ================= */}

      <section className="cqc-feature-strip">
        <div className="cqc-container feature-grids">
          <div className="feature-box">
            <strong>CQC-focused</strong>
            <span>Regulatory expertise</span>
          </div>

          <div className="feature-box">
            <strong>Evidence-led</strong>
            <span>Clear, objective findings</span>
          </div>

          <div className="feature-box">
            <strong>Practical</strong>
            <span>Actions your team can deliver</span>
          </div>

          <div className="feature-box">
            <strong>Responsive</strong>
            <span>Support when it matters</span>
          </div>
        </div>
      </section>

      {/* ================= BLUE NAV STRIP ================= */}

      <div className="blue-anchor-bar">
        <button onClick={() => scrollTo("services")}>Services</button>

        <button onClick={() => scrollTo("why-us")}>Why us</button>

        <button onClick={() => scrollTo("who-we-help")}>Who we help</button>

        <button onClick={() => scrollTo("contact")}>Contact</button>
      </div>

      {/* ================= SERVICES INTRO ================= */}

      <section className="serv-intro" id="Intro">
        <div className="cqc-container">
          <div>
            <div className="small-heading">HOW WE CAN HELP</div>

            <h2>
              Specialist CQC support at every
              <br className="desktop-break" />
              stage of your journey.
            </h2>
          </div>

          <p>
            From preparing your first application to maintaining assurance
            across an established group, our support is focused, proportionate
            and built around your service.
          </p>
        </div>
      </section>

      {/* ================= SERVICES ================= */}

      <section id="services" className="cqc-services-section">
        <div className="cqc-container">
          <div className="services-grid">
            {services.map((service) => (
              <article className="service-card" key={service.number}>
                <span className="service-number">{service.number}</span>

                <h3>{service.title}</h3>

                <p>{service.description}</p>

                <button onClick={() => scrollTo("contact")}>
                  Learn more ↗
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ================= WHY US ================= */}

      <section id="why-us" className="why-section">
        <div className="cqc-container why-grid">
          <div className="why-left">
            <div className="white-small-heading">— WHY TOTAL CARE ADVISORY</div>

            <h2>Compliance should create confidence, not just paperwork.</h2>

            <p>
              We translate regulatory expectations into clear evidence and
              manageable actions. Your team understands what good looks like,
              why it matters and how to demonstrate it consistently.
            </p>

            <button
              className="white-button"
              onClick={() => scrollTo("cqc_contact")}
            >
              Meet your CQC Specialist ↗
            </button>
          </div>

          <div className="why-right">
            <div className="why-item">
              <span>01</span>
              <div>
                <h3>Care-sector experience</h3>
                <p>
                  Advice grounded in the realities of regulated care services
                  and current CQC expectations.
                </p>
              </div>
            </div>

            <div className="why-item">
              <span>02</span>
              <div>
                <h3>Honest assurance</h3>
                <p>
                  Independent findings that recognise good practice and clearly
                  identify gaps or risk.
                </p>
              </div>
            </div>

            <div className="why-item">
              <span>03</span>
              <div>
                <h3>Support beyond the audit</h3>
                <p>
                  Prioritised actions, evidence guidance and follow-up support
                  to help improvements become embedded.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHO WE HELP ================= */}

      <section id="who-we-help" className="who-section">
        <div className="cqc-container">
          <div className="whoWe-card">
            <div className="who-copy">
              <div className="small-heading">— WHO WE HELP</div>

              <h2>
                CQC support shaped
                <br />
                around your care
                <br />
                service.
              </h2>

              <p>
                Whether you are applying to register, preparing for inspection
                or responding to a challenging outcome, we tailor the support to
                your setting, risks and priorities.
              </p>
            </div>

            <div className="who-list">
              {helpItems.map((item) => (
                <div className="who-item" key={item}>
                  <span>✓</span>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= CONTACT ================= */}

      <section id="cqc_contact" className="compliance">
        <div className="contacts-grid">
          <div className="contact-copy">
            <div className="small-heading">LET'S TALK COMPLIANCE</div>

            <h2>Ready to feel more confident about CQC?</h2>

            <p>
              Book a free, no-obligation conversation with our CQC compliance
              team.
            </p>
          </div>

          <div className="consult-card">
            <h2>Book your free consultation</h2>

            <p className="consultation-description">
              Tell us where you are in your CQC journey and we'll arrange a
              convenient time to talk.
            </p>

              <form className="consultation-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Your Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Work Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="you@carebusiness.co.uk"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Organisation</label>
                <input
                  type="text"
                  name="organisation"
                  placeholder="Care service or provider name"
                  value={formData.organisation}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="consultation-button">
                Request a consultation ↗
              </button>
            </form>


            <p className="consultation-email">
              Prefer email?{" "}
              <a href="mailto:info@totalcareadvisory.com">
                info@totalcareadvisory.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CQC_Services;
